import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { TabsCardLayout } from "@icoach/components";


/** ================================
 * 📌 批次扣款 - 主要 Tab 切換器
 *  ================================
 */
const BatchPaymentMainTabSwitcher = ({ sourceData, activeTab, ...rest }) => {
	const { listComponent: ListComponent } = sourceData[activeTab];

	const tabsData = useMemo(() => {
			return Object.keys(sourceData).map((key) => {
				const { label, value, to, buttonComponent } = sourceData[key];
				return {
					label,
					value,
					to,
					component: buttonComponent || Link
				};
			});
		},
		// eslint-disable-next-line
		[sourceData]);

	return (
		<TabsCardLayout
			tabs={tabsData}
			activeTab={activeTab}
			tabsContent={{
				className: "p-4"
			}}
		>
			{React.isValidElement(ListComponent) ? React.cloneElement(ListComponent, { ...rest }) : null}
		</TabsCardLayout>
	);
};


export default BatchPaymentMainTabSwitcher;